<div class="accordion">
  <!-- Accordion 1 -->
  <div
    class="accordion-item"
    *ngFor="let item of permissionRole; let i = index"
  >
    <div class="accordion-header" (click)="toggleAccordion(i + 1)">
      <h3 class="accordion-title">{{ getUserNameById(item.role_id) }}</h3>
      <button class="accordion-toggle">
        <ng-container *ngIf="isOpen === i + 1; else closedIcon">
          <i class="pi pi-chevron-up icon"></i>
        </ng-container>
        <ng-template #closedIcon>
          <i class="pi pi-chevron-down icon"></i>
        </ng-template>
      </button>
    </div>
    <div class="accordion-content" [class.open]="isOpen === i + 1">
      <div
        class="form-item"
        *ngFor="let checkbox of item.permissions; let i = index"
      >
        <div class="items-center" [style.cursor]="isRoleDisabled(item.role_id) ? 'not-allowed' : 'default'">
          <p-checkbox
            [inputId]="getUserNameById(item.role_id).split(',').join('') + i"
            [binary]="true"
            [value]="checkbox.has_permission"
            [(ngModel)]="checkbox.has_permission"
            [disabled]="isRoleDisabled(item.role_id)"
            (onChange)="
              onPermissionChange(
                item.role_id,
                checkbox.permission_id,
                $event.checked
              )
            "
          />
          <label [for]="getUserNameById(item.role_id) + i" class="ml-2" [style.cursor]="isRoleDisabled(item.role_id) ? 'not-allowed' : 'pointer'">
            {{ getPermissionName(checkbox.permission_id) }}- ({{
              getUserDescriptionByID(checkbox.permission_id)
            }})
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
<app-toast-message #toast toastKey="permission-groups"></app-toast-message>
<app-modal
  [visible]="permissionPop"
  [cancelButtonText]="'No'"
  [submitButtonText]="'Yes'"
  [header]="'Permission'"
  (onSubmit)="onSubmitPermission($event)"
  (onCancel)="onCancelPermission($event)"
>
  <div class="permission-content">
    Are you sure you want to change this Permission?
  </div>
</app-modal>
